<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="cancel()" />
</div>

<ion-content [fullscreen]="true">
  <ion-grid class="change-password-container">
    <ion-row>
      <ion-col>
        <ion-title class="smaller">
          <h1>Endre passord?</h1>
        </ion-title>
      </ion-col>
    </ion-row>
    <ion-row class="ion-padding-top">
      <ion-col>
        <form [formGroup]="endrepassordGroup" class="form-input-ihk">
          <div class="password-container">
            <ion-input
              label="Gammelt passord"
              labelPlacement="stacked"
              fill="outline"
              [type]="showOldPassword ? 'text' : 'password'"
              formControlName="oldpassword"
            ></ion-input>
            <ion-icon
              [color]="showOldPassword ? 'primary' : 'medium'"
              [name]="showOldPassword ? 'eye' : 'eye-off'"
              (click)="togglePasswordText(1)"
            ></ion-icon>
          </div>

          <div class="password-container">
            <ion-input
              label="Nytt passord"
              labelPlacement="stacked"
              fill="outline"
              [type]="showPassword ? 'text' : 'password'"
              autocomplete="new-password"
              formControlName="newpassword"
            ></ion-input>
            <ion-icon
              [color]="showPassword ? 'primary' : 'medium'"
              [name]="showPassword ? 'eye' : 'eye-off'"
              (click)="togglePasswordText(2)"
            ></ion-icon>
          </div>
          <div>
            <div class="password-container">
              <ion-input
                label="Gjenta nytt passord"
                labelPlacement="stacked"
                fill="outline"
                [type]="showPasswordConfirmed ? 'text' : 'password'"
                formControlName="newpasswordconfirmed"
              ></ion-input>
              <ion-icon
                [color]="showPasswordConfirmed ? 'primary' : 'medium'"
                [name]="showPasswordConfirmed ? 'eye' : 'eye-off'"
                (click)="togglePasswordText(3)"
              ></ion-icon>
            </div>
          </div>
        </form>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <p class="error-message" *ngIf="!getIsFormValid()">
          {{getFormErrorMessage()}}
        </p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <ion-button (click)="cancel()">Avbryt</ion-button>
      </ion-col>
      <ion-col>
        <ion-button
          class="dark"
          [disabled]="!getIsFormValid()"
          (click)="putPassword()"
          >Lagre</ion-button
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
